import React from "react";
import { useNavigate } from "react-router-dom";
import { Loading } from "../../../components/loading";
import { EmptyList } from "../../../components/empty-list";
import { Table, TableHeader, TableBody, TableRow, TableCell } from "../../../components/tables";
import { useStockUnits } from "../hooks";

interface IProps {
  productId?: number;
  warehouseId?: number;
}

export const StockUnitsList: React.FC<IProps> = ({ productId, warehouseId }) => {
  const navigate = useNavigate();
  const { data, loading } = useStockUnits({
    where: { productId, warehouseId },
  });

  if (loading) return <Loading />;

  if (!data?.stockUnits?.results?.length) {
    return <EmptyList text="Aucun lot en stock" />;
  }

  return (
    <Table>
      <TableHeader>
        <TableRow hover={false}>
          <TableCell header>Lot</TableCell>
          {!productId && <TableCell header>Produit</TableCell>}
          {!warehouseId && <TableCell header>Entrepôt</TableCell>}
          <TableCell header align="right">
            Quantité
          </TableCell>
          <TableCell header align="center">
            Statut
          </TableCell>
        </TableRow>
      </TableHeader>
      <TableBody>
        {data?.stockUnits?.results?.map((unit) => (
          <TableRow
            key={`stock-unit-${unit.id}`}
            onClick={() => navigate(`/stock-unit/${unit.id}`)}
          >
            <TableCell>{unit.batchNumber}</TableCell>
            {!productId && <TableCell>{unit.product?.name}</TableCell>}
            {!warehouseId && <TableCell>{unit.warehouse?.name}</TableCell>}
            <TableCell align="right">{unit.quantity}</TableCell>
            <TableCell align="center">
              {unit.exitedAt ? "Sorti" : "En stock"}
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};
